import './travel-info-bar.scss';

import { checkAndLoadFiles, createElementFromHTML, getOffset } from '../../utilities/js/helper';
import AjaxLoad from '../../utilities/js/ajax-load';

class TravelInfoBar {
    constructor (element) {
        this.$travelInfoBar = element;
        this.$indicator = this.$travelInfoBar.previousElementSibling;
        this.$footer = document.querySelector('[data-footer="root"]');
        this.$printButton = this.$travelInfoBar.querySelector('[data-travel-detail-print]');
        this.$printTarget = document.querySelector('[data-print-target]');
        this.$$tabNavUrls = document.querySelectorAll('[data-tab-nav-url]');
        this.subPagesLoaded = false;
    }

    initialize () {
        this.checkPosition();

        this.setEvents();
    }

    setEvents () {
        window.eventScroller.customFunctions.push(() => {
            this.checkPosition();
        });

        if (this.$printButton) {
            this.$printButton.addEventListener('click', () => {
                if (this.$printTarget) {
                    if (this.$$tabNavUrls.length > 0) {
                        if (!this.subPagesLoaded) {
                            this.subPagesLoaded = true;
                            this.$$tabNavUrls.forEach((item, index) => this.sendRequest(item.dataset.tabNavUrl, index));
                        } else {
                            this.$printTarget.style.display = 'block';
                            window.print();
                        }
                    } else {
                        this.$printTarget.style.display = 'block';
                        window.print();
                    }
                }
            });
        }

        window.addEventListener('print.ready', (e) => {
            this.$printTarget.style.display = 'block';
            window.print();
        });

        window.addEventListener('afterprint', () => {
            this.$printTarget.style.display = '';
        });
    }

    sendRequest (url, index) {
        this.result = new AjaxLoad(url, {
            requestMethod: 'post',
            onSuccess: (resultText) => {
                this.setResult(resultText, index);
            },
            onError: (error) => {
                console.warn(error);
            }
        });
    }

    setResult (results, index) {
        const $result = createElementFromHTML(results);

        if ($result.length > 1) {
            $result.forEach((item) => {
                this.$printTarget.appendChild(item);
            });
        } else {
            this.$printTarget.appendChild($result);
        }

        checkAndLoadFiles(this.$printTarget).then((data) => {
            window.dispatchEvent(new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$printTarget,
                    ajax: true
                }
            }));
        });

        if (index + 1 === this.$$tabNavUrls.length) {
            window.dispatchEvent(new CustomEvent('print.ready', {
                view: window,
                bubbles: true,
                cancelable: false
            }));
        }
    }

    checkPosition () {
        if ((window.scrollPosition + window.innerHeight) >= (getOffset(this.$indicator).top + this.$travelInfoBar.scrollHeight)) {
            this.$indicator.classList.add('is--visible');

            if ((window.scrollPosition + window.innerHeight) > getOffset(this.$footer).top) {
                this.$indicator.classList.remove('is--visible');
            } else {
                this.$indicator.classList.add('is--visible');
            }
        } else {
            if (this.$indicator.classList.contains('is--visible')) {
                this.$indicator.classList.remove('is--visible');
            }
        }
    }
}

export { TravelInfoBar };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $travelInfoBar = $context.querySelector('[data-travel-info-bar="root"]');

        if ($travelInfoBar) {
            const travelInfoBar = new TravelInfoBar($travelInfoBar);
            travelInfoBar.initialize();
        }
    }
});
